var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm._tags),function(tag,i){return _c('v-chip',{key:i,staticClass:"mr-1",attrs:{"x-small":"","pill":"","color":"primary"}},[_vm._v(" "+_vm._s(_vm.capitalizeFirstLetter(tag))+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }